/**
 * แปลง "จำนวนนาทีที่สาย" เป็นข้อความอ่านง่าย — ใช้ร่วมกันทั้งการ์ดแดชบอร์ด
 * (AttendanceTopCard) และหน้า "สรุปมาสาย" (/hr/late-report) กันเขียนซ้ำสองที่.
 */

/** 333 -> "5 ชม. 33 น." · 45 -> "45 น." */
export function lateLabel(mins: number): string {
  const m = Math.round(mins);
  if (m < 60) return `${m} น.`;
  const h = Math.floor(m / 60);
  const rest = m % 60;
  return rest === 0 ? `${h} ชม.` : `${h} ชม. ${rest} น.`;
}
